import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const patternBg = `${process.env.PUBLIC_URL}/pattern.svg`;

/**
 * Shown when a signed-in user is not a member of any MMS staff group, or when a
 * route requires a group they don't have. The backend already rejects non-staff
 * logins; this is the matching front-of-house experience.
 */
const AccessDenied: React.FC = () => {
  const navigate = useNavigate();

  const goToLogin = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    navigate("/login", { replace: true });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#F4E9DE",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Box sx={{ position: "relative", zIndex: 4, textAlign: "center", maxWidth: 520 }}>
        <Typography
          sx={{
            fontFamily: "Mulish, sans-serif",
            fontWeight: 1000,
            fontSize: { xs: "5rem", md: "7rem" },
            lineHeight: 1,
            color: "#6E4A3A",
            userSelect: "none",
          }}
        >
          403
        </Typography>
        <Typography sx={{ color: "#1F1A17", fontSize: { xs: "1.15rem", md: "1.3rem" }, fontWeight: 700, mt: 2, mb: 1 }}>
          You don’t have access to this portal
        </Typography>
        <Typography sx={{ color: "#5D4B41", fontSize: "1rem", mb: 4 }}>
          This account isn’t a member of a Muzukuru staff group. If you believe this is a
          mistake, contact your administrator to be added to the right group.
        </Typography>

        <Button
          onClick={goToLogin}
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: "#6E4A3A",
            color: "#fff",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "1.05rem",
            px: 4.5,
            py: 1.4,
            borderRadius: "12px",
            minWidth: 180,
            "&:hover": { backgroundColor: "#5D3D30" },
          }}
        >
          Back to sign in
        </Button>
      </Box>

      <Box
        component="img"
        src={patternBg}
        alt="Background pattern"
        sx={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: { xs: "180%", sm: "150%", md: "120%" },
          maxWidth: "1650px",
          pointerEvents: "none",
          userSelect: "none",
          zIndex: 0,
        }}
      />
    </Box>
  );
};

export default AccessDenied;
